import React from 'react'

function renderDropdownOptions(options) {
  return options.map((option) => (
    <option key={option.label} value={option.value}>
      {option.label}
    </option>
  ))
}

export default renderDropdownOptions
